import { strings } from "validations";
import * as yup from "yup";

export const aboutUsSchema = yup
  .object({
    title: yup.string().required(strings("").required),
    alt: yup.string(),
  })
  .required();

  export default aboutUsSchema